<template>
    <div class="new-home-avantage-section">
        <p class="discover">
            Ontdek je ledenvoordelen
            <span class="arrow-down"></span>
        </p>

        <ul>
            <li
                v-for="(item, index) in avantage"
                :key="index"
                class="text-uppercase categories"
            >
                <a :href="'#'+removeSpace(item.name)" @click="log($event)">
                    {{ item.categorie }}
                </a>
            </li>
        </ul>
        <NewHomeAvantageDesktop :avantage="avantage"/>
        <NewHomeAvantageAccordion :avantage="avantage"/>
        <div class="start-pack">
            <p>Aanbieding alleen geldig voor nieuwe leden</p>
            <h2>Ontdek Testaankoop<br>
                2 maanden lang <br> <span class="orange-text"> voor € 2</span> </h2>
            <p>
                En kies uw welkomstgeschenk uit tientallen merken
            </p>
            <b-button class="button is-primary next-button" @click="nextStep()"
            >Vraag je pakket aan</b-button
            >

        </div>
    </div>
</template>
<script>
import NewHomeAvantageAccordion from "./NewHomeAvantageAccordion.vue";
import NewHomeAvantageDesktop from "./NewHomeAvantageDesktop.vue";
import mixin from "../../../../components/form/steps/travel_step_mixin";
import image_mixin from "../mixins/image_mixin";

export default {
    mixins: [mixin, image_mixin],

    components: {
        NewHomeAvantageAccordion,
        NewHomeAvantageDesktop,
    },
    methods: {
        log(e) {
            console.log(e);
        }
    },
    computed: {
        avantage() {
            return [
                {
                    categorie: `Bespaar €${this.economy_amount}`,
                    name: `Bespaar €${this.economy_amount}`,
                    title: `Bespaar tot €${this.economy_amount}  per jaar*`,
                    description: `Neemt je energiefactuur een flinke hap uit het gezinsbudget? Misschien een goede gelegenheid om ál je kosten eens onder de loep te nemen: supermarkt, auto, verzekeringen, telecom … Met onze tips kun je elk jaar tot €${this.economy_amount}* besparen. <br><br>
      <span class="text-asterix">*gemiddelde prijs op basis van een jaarlijks onderzoek.</span>`,
                    img: "/images/nl_new_home/avantage-image/img_1_avantage.png",

                },
                {
                    categorie: "members club",

                    name: "Members Club",
                    title: `Geniet van exclusieve kortingen`,
                    description: `Geniet van exclusieve kortingen als lid van Testaankoop voor verschillende producten, van vakanties en citytrips tot shopping, financiën en cadeaukaarten. De kortingen zijn toepasbaar op topmerken zoals Samsonite, Colruyt, Ici Paris XL, Zalando, Deltrian, Dreamland, Kinepolis, Ikea, Gamma en nog véél meer.`,
                    img: "/images/nl_new_home/avantage-image/img_2_avantage.png",
                },
                {
                    categorie: "Juridisch advies",

                    name: "Juridisch advies",
                    title: `Juridisch advies: 80% van de geschillen opgelost `,
                    description: `Een conflict met een bedrijf? Dien een klacht in via ons platform.  De handtekening van Testaankoop geeft je klacht meer gewicht en versnelt de reactie van het merk met gemiddeld 4 dagen.    En als dat niet volstaat, staan er honderd advocaten klaar om je te helpen je rechten te doen gelden. `,
                    img: "/images/nl_new_home/avantage-image/img_3_avantage.png",
                },
                {
                    categorie: "energievoordeel",

                    name: "energievoordeel",
                    title: `De beste energieleveranciers vinden <span class="hide-mobile">tegen de beste prijs, en de juiste keuze maken? </span> `,
                    description: `Contracten en voorwaarden van energieleveranciers lijken soms ondoorgrondelijk.  Als je lid bent van Testaankoop, krijg je al het juridisch advies, de kennis en de ervaring van onze experts in de omgang met energieleveranciers.`,
                    img: "/images/nl_new_home/avantage-image/img_4_avantage.png",
                },
                {
                    categorie: "Getest door experts",

                    name: "Getest door experts",
                    title: `Veilige en persoonlijke keuzes`,
                    description: `Van energieleverancier veranderen, een wasmachine kopen of je ziekenfonds kiezen?
 Onze koopwijzers leiden je naar het product dat het beste aansluit bij jouw prioriteiten.  Een specifieke vraag over isolatie, energiepremies, antivirusprogramma’s, je belastingaangifte? Bel ons! Onze specialisten geven je persoonlijk antwoord.`,
                    img: "/images/fr_new_home/avantage-image/img_5_avantage_nl.png",
                },
            ]
        }
    },
    mounted() {
        let categories = document.querySelector(".new-home-avantage-section")

            for (let i = 0; i < categories.querySelectorAll('a[href^="#"]').length ; i++) {
                categories.querySelectorAll('a[href^="#"]')[i].addEventListener('click', (e)=>{
                    e.preventDefault();
                    categories.querySelector(categories.querySelectorAll('a[href^="#"]')[i].getAttribute('href')).scrollIntoView({
                        behavior: 'smooth'
                    });
                });
            }


    }
};
</script>
